import $ from 'jquery';

import { $Elements, Events, Classes, Elements } from '../global/constants';
import { ajax } from '../global/helpers';
import { initSwiperReviews } from '../global/sections';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Ajax Vintages ----------

	if(typeof wines_api_params !== 'undefined') {

		$('form.ajax-vintage-form').each(function() {

			const form = $(this);
			const filters = form.find('.ajax-vintage-filter');
			const content = $('#ajax-wrapper-sections');
			const noResults = content.find('.no-results-section');

			filters.on('change', () => {
				form.data('append', false);
				form.submit();
			});

			filters.on('click', function() {
				filters.parent().removeClass('active');
				$(this).parent().addClass('active');
			})

			form.on('submit', async e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				Elements.LoadingBar.classList.add(Classes.loading);
				form.addClass(Classes.loading);
				content.addClass(Classes.loading);

				const form_data = new FormData(form[0]);
				form_data.append('action', wines_api_params.action);
				form_data.append('nonce', wines_api_params.nonce);

				try {

					const response = await ajax({
						url: wines_api_params.admin_url,
						type: 'POST',
						dataType: 'json',
						data: form_data,
						processData: false,
						contentType: false,
					});

					if(response.data.content) {
						noResults.addClass(Classes.hidden);

						if(!form.data('append')) {
							content.empty();
						}

						content.append($(response.data.content).children());
						initSwiperReviews();
					}
					else {
						noResults.removeClass(Classes.hidden);
					}
				}
				catch(e) {
					noResults.removeClass(Classes.hidden);
				}

				Elements.LoadingBar.classList.remove(Classes.loading);
				form.removeClass(Classes.loading);
				content.removeClass(Classes.loading);

				return false;
			});

			form.submit();
		});
	}
});
